var _rect, _path, _path2;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgYoutube(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    rx: 2.5,
    fill: "#DD352E"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.8398 20H3.16017C1.96724 20 1 19.0727 1 17.9291V6.07091C1 4.92727 1.96724 4 3.16017 4H20.8398C22.0328 4 23 4.92727 23 6.07091V17.9291C23 19.0727 22.0328 20 20.8398 20Z",
    fill: "#DD352E"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.96558 15.8288V8.17066C8.96558 7.77394 9.41582 7.52739 9.77237 7.72921L16.5317 11.5583C16.8818 11.7568 16.8818 12.2427 16.5317 12.4408L9.77237 16.2699C9.41582 16.4721 8.96558 16.2256 8.96558 15.8288Z",
    fill: "white"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgYoutube);
export default __webpack_public_path__ + "static/media/youtube.e47aa9d029c55dcc541e2629340fa566.svg";
export { ForwardRef as ReactComponent };